module.exports = "/_next/static/media/search-palet-color.6083843e.png";